import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";

// Wave-17 Item 1.1 — FilingList lazy-loaded.
const FilingList = lazy(() => import("@/pages/FilingList/Page"));

const FilingsRoute = () => (
  <div className="flex flex-col w-full">
    <SiteHeader header="Filings" />
    <Suspense fallback={null}>
      <FilingList />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/filings/")({
  component: FilingsRoute,
});
